export default "__VITE_ASSET__2S4NpQAQ__"